import { mapValues } from 'lodash';
/**
 * Version 34 migrations registration summary widget - Air request
 * - Adding default configurations for air request on registration summary
 */
export default function v34(website) {
  return {
    ...website,
    eventVersion: 34,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'RegistrationSummary') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              airRequestStyles: {
                ...layoutItem.config.style.airRequestStyles,
                sectionSubheaders: {
                  styleMapping: 'header4'
                },
                tableHeader: {
                  styleMapping: 'body1',
                  customSettings: {
                    background: {
                      color: 'primary'
                    },
                    spacing: {
                      padding: {
                        paddingBottom: 9,
                        paddingTop: 9,
                        paddingLeft: 10,
                        paddingRight: 10
                      }
                    }
                  }
                },
                airportNames: {
                  styleMapping: 'custom',
                  text: {
                    fontSize: 16,
                    lineHeight: 1.3,
                    fontFamily: 'primary',
                    color: 'text',
                    fontWeight: 700,
                    fontStyle: 'normal'
                  },
                  background: {
                    image: {},
                    color: null,
                    borderRadius: 0
                  },
                  border: {
                    thickness: 0,
                    color: null,
                    borderStyle: 'solid'
                  },
                  spacing: {
                    padding: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      paddingRight: 0
                    }
                  }
                },
                flightClass: {
                  styleMapping: 'body1'
                },
                travelDates: {
                  styleMapping: 'body1'
                },
                itemBackground: {
                  styleMapping: 'custom',
                  border: {
                    thickness: 0,
                    borderStyle: 'solid'
                  }
                }
              }
            }
          }
        };
      } else if (layoutItem.widgetType === 'AirRequest') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              requestSummary: {
                ...layoutItem.config.style.requestSummary,
                passengerName: {
                  styleMapping: 'header3'
                },
                tableHeader: {
                  styleMapping: 'body1',
                  customSettings: {
                    background: {
                      color: 'primary'
                    },
                    spacing: {
                      padding: {
                        paddingBottom: 5,
                        paddingTop: 5,
                        paddingLeft: 20,
                        paddingRight: 20
                      }
                    }
                  }
                }
              }
            }
          }
        };
      } else if (layoutItem.widgetType === 'AirActualSummary') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              accent: {
                ...layoutItem.config.style.accent,
                background: {
                  image: null,
                  color: 'primary',
                  borderRadius: 0
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
